/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import type ServicedeskQueuesIssueViewRedirectType from '@jira/spa-apps__servicedesk-queues-issue-view-redirect/src/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

export const LazyServicedeskQueuesIssueViewRedirect: LazyComponent<() => React.JSX.Element> =
	lazyForPaint<typeof ServicedeskQueuesIssueViewRedirectType>(
		() =>
			import(
				/* webpackChunkName: "async-servicedesk-queues-issue-view-redirect", jiraSpaEntry: "async-servicedesk-queues-issue-view-redirect" */ '@jira/spa-apps__servicedesk-queues-issue-view-redirect/src/index.tsx'
			),
	);

const AsyncServicedeskQueuesIssueViewRedirect = (): React.JSX.Element => (
	<LazyPage
		Page={LazyServicedeskQueuesIssueViewRedirect}
		pageId="spa-apps/servicedesk/queues/issue-view-redirect"
		shouldShowSpinner
	/>
);

export default AsyncServicedeskQueuesIssueViewRedirect;
